import { __ } from '~/locale';

export const mrStates = {
  merged: 'merged',
  closed: 'closed',
};

export const humanMRStates = {
  merged: __('Merged'),
  closed: __('Closed'),
  open: __('Open'),
};
